import { productShowReservedValidate } from '../../application/dtos/product_show_reserved_validate';

export class productShowReservedEntity {
    constructor({code, success, fault}){
        this.code = code;
        this.success = success;
        this.fault = fault;
    }

    isValid() {
        return productShowReservedValidate(this);
    }
}